import React from 'react';
import { useQuery } from 'react-query';
import { Flex, Box } from '@rebass/grid';
import { Avatar, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import format from 'date-fns/format';
import get from 'lodash.get';
import { fetchUserInfo } from '../../lib/fetchers/users';

const styles = {
  avatar: {
    width: '36px',
    height: '36px',
  },
};

const PostAuthor = ({ classes, authorId, fallbackName, createdAt }) => {
  const { data } = useQuery(['user', authorId], () => fetchUserInfo(authorId), {
    enabled: !!authorId,
    refetchOnWindowFocus: false,
  });

  const name = get(data, 'name') || fallbackName || 'Gym staff';
  const avatarUrl = get(data, 'avatar_url');

  return (
    <Flex alignItems="center">
      <Avatar src={avatarUrl} className={classes.avatar}>
        {name.charAt(0).toUpperCase()}
      </Avatar>
      <Box ml="12px">
        <Typography variant="body2" style={{ fontWeight: 600 }}>
          {name}
        </Typography>
        {createdAt && (
          <Typography variant="caption" color="textSecondary">
            {format(new Date(createdAt), 'MMM D, YYYY h:mm A')}
          </Typography>
        )}
      </Box>
    </Flex>
  );
};

export default withStyles(styles)(PostAuthor);
